import { ProgramSource } from '../../../../queries/ats/titles/types/sources';
import { FocusedAsset } from '../../use-focused-asset';
import { getTimeStatus } from '../utils';
import { FutureProgramCallToAction } from './future-program-call-to-action';
import { PastProgramCallToAction } from './past-program-call-to-action';
import { PresentProgramCallToAction } from './present-program-call-to-action';

export interface ProgramCallToActionProps {
  source: ProgramSource;
  focusedAsset: FocusedAsset;
}

export function ProgramCallToAction(props: ProgramCallToActionProps) {
  const status = getTimeStatus(props.source);

  switch (status) {
    case 'future':
      return <FutureProgramCallToAction {...props} />;
    case 'past':
      return <PastProgramCallToAction {...props} />;
    case 'present':
      return <PresentProgramCallToAction {...props} />;
  }
}
